import React from 'react'
import ContentLoader from 'react-content-loader'
import { useListControlIds } from 'src/components/async/model/control'
import { AuditRecord } from '@trustero/trustero-api-web/lib/audit/audit_pb'
import { ListControlsRequest } from '@trustero/trustero-api-web/lib/model/control_pb'
import { Grid } from '../../../../components/Reusable/Grid'
import { useControlRequest } from '../ControlsIndexPage.utils'
import { ControlsIndexGridHeader } from './ControlsIndexGridHeader'
import { CONTROL_GRID_LOCATIONS } from './ControlsIndexPage.constants'
import {
  ControlGridRows,
  getControlsGridEmptyState,
} from './ControlsIndexGrid.helpers'
import { SpinnerContainer } from './ControlsIndexGrid.styles'

interface ControlsIndexGridProps {
  audit?: AuditRecord
  modelIds?: string[]
  location?: CONTROL_GRID_LOCATIONS
}

export const ControlsIndexGrid = ({
  audit,
  modelIds,
  location,
}: ControlsIndexGridProps): JSX.Element => {
  const listCtrlReq = useControlRequest()
  // this prevents some weird behavior caused by the fact that controls and receptors can both have a 'status' filter param
  const request =
    location === CONTROL_GRID_LOCATIONS.RECEPTORS_SHOW
      ? new ListControlsRequest()
      : listCtrlReq
  const { data, isLoading } = useListControlIds(request)
  // Only fetch full control id list if on Controls Index page, otherwise only render control IDs passed to grid
  const controlIds: string[] = modelIds?.length
    ? modelIds
    : (location === CONTROL_GRID_LOCATIONS.CONTROLS_INDEX &&
        data?.getItemList()) ||
      []

  if (isLoading || !data) {
    return (
      <SpinnerContainer>
        <ContentLoader />
      </SpinnerContainer>
    )
  }
  const controlGridEmptyState = getControlsGridEmptyState(location)

  return !controlIds?.length ? (
    <>{controlGridEmptyState}</>
  ) : (
    <Grid
      pb="xs"
      gridTemplateColumns="min-content min-content minmax(auto, 30%) repeat(5, auto)"
    >
      <ControlsIndexGridHeader location={location} />
      <ControlGridRows modelIds={controlIds} audit={audit} />
    </Grid>
  )
}
